import React, { ElementType, FC, forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';

export interface FooterSectionMenuProps extends BoxProps<ElementType> {}

/**
 * Section for the multiple FooterMenu
 */
export const FooterSectionMenu: FC<FooterSectionMenuProps> = forwardRef(
  ({ sx, children, className, contactSlot, contactSlotProps, socialSlot, socialSlotProps, ...rest }, ref) => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'stretch', lg: 'flex-start' },
          justifyContent: 'stretch',
          flexDirection: { xs: 'column', lg: 'row' },
          gap: { xs: 0, lg: 2 },
          mb: { xs: 4, lg: 8 },
          ...sx,
        }}
        ref={ref}
        data-testid="FooterSectionMenu"
        className={['FooterSectionMenu-root', className].filter(Boolean).join(' ')}
        {...rest}
      >
        {children}
      </Box>
    );
  },
);
